import React, { useState, useEffect } from "react";
import { Modal, Button, DatePicker, Form, message } from "antd";
import moment from "moment";
import { SelectEmployee } from "../SelectInput";
import { useSelector } from "react-redux";
import DatePickerComponent from "../DatePicker";

const WorkSheetModal = ({ open, onClose, onSubmit }) => {
  const { allEmployee } = useSelector((state) => state.employees);
  const [form] = Form.useForm();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) {
        return false;
      }
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee)

  useEffect(() => {
    if (open) {
      form.resetFields();
      setFromDate(null);
      setToDate(null);
    }
  }, [open]);

  return (
    <Modal
      title="Get Full Month Worksheet"
      open={open}
      onCancel={onClose}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={async (values) => {
          const { employeeId } = values;


          if (!fromDate || !toDate) {
            message.error("Please select both From Date and To Date.");
            return;
          }

          let vemployeeid = employeeId;
          const vfromdate = moment(fromDate).format("DD-MMMM-YYYY");
          const vtodate = moment(toDate).format("DD-MMMM-YYYY");

          await onSubmit({ vemployeeid, vfromdate, vtodate });
          onClose();
          setFromDate(null);
          setToDate(null);
        }}

      >
        <Form.Item
          label="Employee Name"
          name="employeeId"
          rules={[{ required: true, message: "Please select employee" }]}
        >
          <SelectEmployee
            employeeList={filterData}
            onChange={(value) => form.setFieldsValue({ employeeId: value })}
            customStyle="w-full"
            allLabel={{}}
          />
        </Form.Item>
        <span className="flex gap-4 py-4 ">

          <DatePickerComponent
            onChange={(date, dateString) => setFromDate(dateString)}
            date={fromDate}
            customStyle="h-10 w-full sm:w-[250px]"
          />
          <DatePickerComponent
            onChange={(date, dateString) => setToDate(dateString)}
            date={toDate}
            customStyle="h-10 w-full sm:w-[250px]"
          />

        </span>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="w-full"
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default WorkSheetModal;
